export enum TagApiUrlsEnum {
  GetTags = '/api/Tag/GetTags',
  GetTagsLookup = '/api/Tag/GetTagsLookup',
  CreateEditTag = '/api/Tag/CreateEditTag',
  DeleteTag = '/api/Tag/DeleteTag'
}
